import { ReportPostType, ReportValues } from '../../local_modules/reports/type/modal-for-report-type'
import { BaseModel } from './base-model'

export abstract class WeatherRoutingBase extends BaseModel {
    abstract eospReportFetch(scheduleId: string): Promise<ReportValues | undefined>;
    abstract sospReportFetch(scheduleId: string): Promise<ReportValues | undefined>;
    abstract noonReportFetch(scheduleId: string, id: number): Promise<ReportValues | undefined>;
    abstract departureReportSend(scheduleId: string):  Promise<ReportPostType>
    abstract departureReportPut(payload: object):  Promise<any>
    abstract departureReportSubmit(payload: object):  Promise<any>
    abstract arrivalReportSend(scheduleId: string):  Promise<ReportPostType>
    abstract arrivalReportPut(payload: object):  Promise<any>
    abstract arrivalReportSubmit(payload: object):  Promise<any>
    abstract reportIdPaginationFetch(scheduleId:string):  Promise<any>
    abstract noonReportSend(scheduleId: string):  Promise<ReportPostType>
    abstract noonReportPut(payload: object):  Promise<any>
    abstract noonReportSubmit(payload: object):  Promise<any>
    abstract showReportPopup(reportType: string, scheduleId: string, reportId: number, minimizedPopUp:boolean): void;
    abstract checkIfReportExists(scheduleId: string, reportType: string): Promise<any>;
    abstract shouldCreateDepartureReportNotification(): Promise<boolean>;
}

let WeatherRoutingModel: WeatherRoutingBase | null = null

function setWeatherRoutingModel(model: WeatherRoutingBase) {
    WeatherRoutingModel = model
}

export { WeatherRoutingModel, setWeatherRoutingModel }
